export const CLEAN_PENDING_ACTIONS = 'Clean Pending Actions';
export const ADD_PENDING_ACTION = 'Add Pending Action';
